import { MdBusiness, MdVerifiedUser, MdBuild, MdGavel, MdPhoneInTalk } from 'react-icons/md';

export const BENEFITS = [
  {
    id: 'integrales',
    title: 'Soluciones integrales',
    description: 'Diseño, suministro, instalación y mantenimiento en un solo proveedor.',
    icon: MdBusiness,
  },
  {
    id: 'ingenieria',
    title: 'Ingeniería especializada',
    description: 'Equipo multidisciplinario en ventas, proyectos, logística y administración.',
    icon: MdVerifiedUser,
  },
  {
    id: 'equipos',
    title: 'Equipos de calidad',
    description: 'Trabajamos con marcas reconocidas del sector eléctrico industrial.',
    icon: MdBuild,
  },
  {
    id: 'normativo',
    title: 'Cumplimiento normativo',
    description: 'Mediciones, pruebas y emisión de certificaciones de nuestros trabajos.',
    icon: MdGavel,
  },
  {
    id: 'soporte',
    title: 'Soporte y mantenimiento',
    description: 'Acompañamiento preventivo y correctivo después de la puesta en marcha.',
    icon: MdPhoneInTalk,
  },
];
